import { jsx, jsxs } from "react/jsx-runtime";
import { Typography } from "@mui/material";
import { memo, useState } from "react";
import { selectMatched } from "../utils/selectMatched.js";
import "../../../Button/Button.js";
import "../../../InputControl/InputControl.js";
import "../../../InputControl/Input/InputBase.js";
import "../../../PhoneInputControl/PhoneInputControl.js";
import "../../../PhoneInputControl/PhoneInput/PhoneInput.js";
import "../../../IconButton/IconButton.js";
import "../../../common/ControlBody.js";
import "../../../IconButtonNew/IconButton.js";
import "../../../../icons/24/Action/Close.js";
import "../../../../icons/24/Arrow/ChevronLeft.js";
import { inheritDataTestId } from "../../../../utils/dataTestId.js";
import "../../../Dropdown/context/DropdownContext.js";
import "../../../Dropdown/DropdownWindow.js";
import { DATA_TEST_ID_INHERITED } from "../../../../constants/DATA_TEST_ID_INHERITED.js";
import "../../../../icons/24/System/Check.js";
import "../../../../icons/24/Arrow/ChevronDown.js";
import "../../../SelectControl/SelectInput/SelectInput.js";
import "../../../TextareaControl/TextareaControl.js";
import "../../../SearchControl/SearchControl.js";
import "../../../../icons/24/System/Search.js";
import "../../../FormattedPhone/FormattedPhoneNumber.js";
import { Tooltip } from "../../../Tooltip/Tooltip.js";
import "../../../Avatar/styles.js";
import "../../../CheckboxGroup/Checkbox/styles.js";
import "../../../CheckboxGroup/styles.js";
import "../../../RadioGroup/Radio/styles.js";
import "../../../RadioGroup/styles.js";
import "../../../RatingButton/styles.js";
import "../../../FloatingActionButton/styles.js";
import "../../../SortingButton/styles.js";
import "../../../SquareButton/styles.js";
import "../../../Toggle/styles.js";
import "../../../Dialog/Dialog.js";
import "../../../Dialog/DialogTitle.js";
import "../../../Dialog/DialogActions.js";
import "../../../Dialog/DialogContent.js";
import "../../../Chips/Chip/styles.js";
import "../../../ResultMarksNumber/styles.js";
import "../../../Progress/ProgressCircle/styles.js";
import "../../../Loaders/LoaderCircle/styles.js";
import "../../../Loaders/LoaderLine/styles.js";
import "../../../SegmentedControl/styles.js";
import "../../../ResultMarksText/styles.js";
import "../../../Link/Link.js";
import "../../../Tag/Tag.js";
import "../../../DatePicker/constants.js";
import "../../../DatePicker/shared/fragments/CalendarCell/CalendarCell.js";
import "../../../../vendor/classnames/index.js";
import "../../../Scrollbar/Scrollbar.js";
import "../../../DatePicker/shared/fragments/MonthYearSelector/YearSelector.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContext.js";
import "../../../DatePicker/components/RangePicker/context/DateRangePickerContextActions.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContext.js";
import "../../../DatePicker/components/DatePicker/context/DatePickerContextActions.js";
import "../../../../icons/24/Action/Attach.js";
import "../../../../icons/24/Action/Camera.js";
import "../../../../icons/24/Action/CameraPlus.js";
import "../../../../icons/24/Action/Cart.js";
import "../../../../icons/24/Action/ChatText.js";
import "../../../../icons/24/Action/ClockClockwise.js";
import "../../../../icons/24/Action/ClockCounterClockwise.js";
import "../../../../icons/24/Action/Comment.js";
import "../../../../icons/24/Action/Copy.js";
import "../../../../icons/24/Action/DelayedResult.js";
import "../../../../icons/24/Action/Delete.js";
import "../../../../icons/24/Action/DeliveredResult.js";
import "../../../../icons/24/Action/Edit.js";
import "../../../../icons/24/Action/ErrorCheck.js";
import "../../../../icons/24/Action/ErrorMinus.js";
import "../../../../icons/24/Action/ErrorPlus.js";
import "../../../../icons/24/Action/EyeDropper.js";
import "../../../../icons/24/Action/EyeOff.js";
import "../../../../icons/24/Action/EyeOn.js";
import "../../../../icons/24/Action/File.js";
import "../../../../icons/24/Action/FileCheck.js";
import "../../../../icons/24/Action/FilePdf.js";
import "../../../../icons/24/Action/FilePlus.js";
import "../../../../icons/24/Action/Folder.js";
import "../../../../icons/24/Action/FolderPlus.js";
import "../../../../icons/24/Action/Hand.js";
import "../../../../icons/24/Action/Heart.js";
import "../../../../icons/24/Action/Image.js";
import "../../../../icons/24/Action/Key.js";
import "../../../../icons/24/Action/Location.js";
import "../../../../icons/24/Action/Lock.js";
import "../../../../icons/24/Action/Map.js";
import "../../../../icons/24/Action/MassInput.js";
import "../../../../icons/24/Action/Message.js";
import "../../../../icons/24/Action/MessageOpen.js";
import "../../../../icons/24/Action/MessageSend.js";
import "../../../../icons/24/Action/PanelExpand.js";
import "../../../../icons/24/Action/PanelHide.js";
import "../../../../icons/24/Action/PauseCircle.js";
import "../../../../icons/24/Action/Pin.js";
import "../../../../icons/24/Action/PinSlash.js";
import "../../../../icons/24/Action/PlayCircle.js";
import "../../../../icons/24/Action/Print.js";
import "../../../../icons/24/Action/Rating.js";
import "../../../../icons/24/Action/RequestSend.js";
import "../../../../icons/24/Action/SlidersHorizontal.js";
import "../../../../icons/24/Action/SlidersVertical.js";
import "../../../../icons/24/Action/SortAscending.js";
import "../../../../icons/24/Action/SortDescending.js";
import "../../../../icons/24/Action/StopCircle.js";
import "../../../../icons/24/Action/Terminal.js";
import "../../../../icons/24/Action/Unlock.js";
import "../../../../icons/24/Action/User.js";
import "../../../../icons/24/Action/UserInfo.js";
import "../../../../icons/24/Action/UserPlus.js";
import "../../../../icons/24/Action/UsersThree.js";
import "../../../../icons/24/Arrow/ArrowDown.js";
import "../../../../icons/24/Arrow/ArrowLeft.js";
import "../../../../icons/24/Arrow/ArrowRedo.js";
import "../../../../icons/24/Arrow/ArrowRefresh.js";
import "../../../../icons/24/Arrow/ArrowRight.js";
import "../../../../icons/24/Arrow/ArrowRotate.js";
import "../../../../icons/24/Arrow/ArrowSquareOut.js";
import "../../../../icons/24/Arrow/ArrowUndo.js";
import "../../../../icons/24/Arrow/ArrowUp.js";
import "../../../../icons/24/Arrow/ArrowUpLeft.js";
import "../../../../icons/24/Arrow/ArrowUpRight.js";
import "../../../../icons/24/Arrow/ArrowsDownUp.js";
import "../../../../icons/24/Arrow/ArrowsLeftRight.js";
import "../../../../icons/24/Arrow/ArrowsOutCardinal.js";
import "../../../../icons/24/Arrow/ArrowsSort.js";
import "../../../../icons/24/Arrow/ChevronDoubleLeft.js";
import "../../../../icons/24/Arrow/ChevronDoubleRight.js";
import "../../../../icons/24/Arrow/ChevronRight.js";
import "../../../../icons/24/Arrow/ChevronUp.js";
import "../../../../icons/24/Arrow/CollapseWindow.js";
import "../../../../icons/24/Arrow/ExpandWindow.js";
import "../../../../icons/24/Arrow/Request.js";
import "../../../../icons/24/Emotion/Bad.js";
import "../../../../icons/24/Emotion/Good.js";
import "../../../../icons/24/Emotion/Neutral.js";
import "../../../../icons/24/Emotion/VeryBad.js";
import "../../../../icons/24/Emotion/VeryGood.js";
import "../../../../icons/24/Math/Average.js";
import "../../../../icons/24/Math/Divide.js";
import "../../../../icons/24/Math/Equals.js";
import "../../../../icons/24/Math/Less.js";
import "../../../../icons/24/Math/LessEquals.js";
import "../../../../icons/24/Math/Minus.js";
import "../../../../icons/24/Math/MinusCircle.js";
import "../../../../icons/24/Math/More.js";
import "../../../../icons/24/Math/MoreEquals.js";
import "../../../../icons/24/Math/NoEquals.js";
import "../../../../icons/24/Math/Number.js";
import "../../../../icons/24/Math/Plus.js";
import "../../../../icons/24/Math/PlusCircle.js";
import "../../../../icons/24/Math/X.js";
import "../../../../icons/24/Menu/Archive.js";
import "../../../../icons/24/Menu/Billing.js";
import "../../../../icons/24/Menu/BoardGraph.js";
import "../../../../icons/24/Menu/BoardText.js";
import "../../../../icons/24/Menu/Buildings.js";
import "../../../../icons/24/Menu/BurgerMenu.js";
import "../../../../icons/24/Menu/CalendarBlank.js";
import "../../../../icons/24/Menu/CalendarCheck.js";
import "../../../../icons/24/Menu/ChartLine.js";
import "../../../../icons/24/Menu/ChartLineUp.js";
import "../../../../icons/24/Menu/Cytology.js";
import "../../../../icons/24/Menu/Dashboard.js";
import "../../../../icons/24/Menu/Emailbook.js";
import "../../../../icons/24/Menu/GenderFemale.js";
import "../../../../icons/24/Menu/GenderMale.js";
import "../../../../icons/24/Menu/Hospital.js";
import "../../../../icons/24/Menu/Lightning.js";
import "../../../../icons/24/Menu/Microbiology.js";
import "../../../../icons/24/Menu/Microphone.js";
import "../../../../icons/24/Menu/Microscope.js";
import "../../../../icons/24/Menu/Monitor.js";
import "../../../../icons/24/Menu/MonitorGraph.js";
import "../../../../icons/24/Menu/Note.js";
import "../../../../icons/24/Menu/NoteSearch.js";
import "../../../../icons/24/Menu/Notebook.js";
import "../../../../icons/24/Menu/Order.js";
import "../../../../icons/24/Menu/Package.js";
import "../../../../icons/24/Menu/PencilCircle.js";
import "../../../../icons/24/Menu/Phone.js";
import "../../../../icons/24/Menu/PhoneArrow.js";
import "../../../../icons/24/Menu/PhoneCall.js";
import "../../../../icons/24/Menu/PhoneCheck.js";
import "../../../../icons/24/Menu/Phonebook.js";
import "../../../../icons/24/Menu/Plugs.js";
import "../../../../icons/24/Menu/PlusMinus.js";
import "../../../../icons/24/Menu/Relations.js";
import "../../../../icons/24/Menu/Robot.js";
import "../../../../icons/24/Menu/Room.js";
import "../../../../icons/24/Menu/Selections.js";
import "../../../../icons/24/Menu/Smartphone.js";
import "../../../../icons/24/Menu/Stethoscope.js";
import "../../../../icons/24/Menu/TestFlask.js";
import "../../../../icons/24/Menu/TestTube.js";
import "../../../../icons/24/Menu/TestTubeArchive.js";
import "../../../../icons/24/Menu/TestTubeControl.js";
import "../../../../icons/24/Menu/TestTubeReception.js";
import "../../../../icons/24/Menu/TestTubeRegistration.js";
import "../../../../icons/24/Menu/Tray.js";
import "../../../../icons/24/Menu/UserCircle.js";
import "../../../../icons/24/Menu/Wrench.js";
import "../../../../icons/24/Menu/FirstAidKit.js";
import "../../../../icons/24/Menu/СhartBar.js";
import "../../../../icons/24/System/Alarm.js";
import "../../../../icons/24/System/Barcode.js";
import "../../../../icons/24/System/Calendar.js";
import "../../../../icons/24/System/Checks.js";
import "../../../../icons/24/System/Clock.js";
import "../../../../icons/24/System/CloudDownload.js";
import "../../../../icons/24/System/CloudUpload.js";
import "../../../../icons/24/System/DotsSixHorizontal.js";
import "../../../../icons/24/System/DotsSixVertical.js";
import "../../../../icons/24/System/DotsThreeHorizontal.js";
import "../../../../icons/24/System/DotsThreeVertical.js";
import "../../../../icons/24/System/Download.js";
import "../../../../icons/24/System/Link.js";
import "../../../../icons/24/System/LinkBreak.js";
import "../../../../icons/24/System/Loader.js";
import "../../../../icons/24/System/Notification.js";
import "../../../../icons/24/System/QRcode.js";
import "../../../../icons/24/System/Settings.js";
import "../../../../icons/24/System/Shield.js";
import "../../../../icons/24/System/SignIn.js";
import "../../../../icons/24/System/SignOut.js";
import "../../../../icons/24/System/Spinner.js";
import "../../../../icons/24/System/Upload.js";
import "../../../../icons/24/System/ZoomIn.js";
import "../../../../icons/24/System/ZoomOut.js";
import "../../../../icons/24/Text/Aa.js";
import "../../../../icons/24/Text/AlignCenter.js";
import "../../../../icons/24/Text/AlignLeft.js";
import "../../../../icons/24/Text/AlignRight.js";
import "../../../../icons/24/Text/Bolder.js";
import "../../../../icons/24/Text/Columns.js";
import "../../../../icons/24/Text/H.js";
import "../../../../icons/24/Text/Italic.js";
import "../../../../icons/24/Text/ListBullets.js";
import "../../../../icons/24/Text/ListNumbers.js";
import "../../../../icons/24/Text/Rows.js";
import "../../../../icons/24/Text/Strikethrough.js";
import "../../../../icons/24/Text/Table.js";
import "../../../../icons/24/Text/TableDouble.js";
import "../../../../icons/24/Text/Underline.js";
import "../../../../icons/24/Warning/Attention.js";
import "../../../../icons/24/Warning/Error.js";
import "../../../../icons/24/Warning/Info.js";
import "../../../../icons/24/Warning/Question.js";
import "../../../../icons/24/Warning/Success.js";
import "../../../MobileBottomSheet/MobileBottomSheet.js";
import "../../../ListItem/ListItem.js";
import "../../../Nowrap.js";
import "../TreeListItem.js";
import "../../../../icons/IconsFilled/24/Alert/Success.js";
import "../../../../icons/IconsFilled/24/Alert/Information.js";
import "../../../../icons/IconsFilled/24/Alert/Attention.js";
import "../../../../icons/IconsFilled/24/Alert/Error.js";
import "../../../Tabs/styles.js";
import "../../../Tabs/context.js";
import "../../../CounterInput/Input.js";
import "../../../PinCodeControl/PinCodeInput.js";
const Label = memo(({ label, lines, match, disabled, htmlFor, ...props }) => {
  const [tooltipCanBeShown, setTooltipIsEnabled] = useState(!1), tooltipIsNeeded = label.length > 50 && lines === 1;
  let content = (htmlFor2) => /* @__PURE__ */ jsx(
    Typography,
    {
      "data-test-id": DATA_TEST_ID_INHERITED,
      component: "label",
      className: "contentContainer no-match-content",
      sx: [
        styles.label,
        lines === 1 ? { whiteSpace: "nowrap" } : {},
        disabled ? styles.disabled : {}
      ],
      onClick: () => setTooltipIsEnabled(!0),
      htmlFor: htmlFor2,
      ...props,
      children: label
    }
  );
  if (match) {
    const txtObj = selectMatched(match, label);
    match && txtObj.selected && (content = (htmlFor2) => /* @__PURE__ */ jsxs(
      Typography,
      {
        "data-test-id": DATA_TEST_ID_INHERITED,
        component: "label",
        className: "contentContainer match-content",
        sx: [
          styles.label,
          lines === 1 ? { whiteSpace: "nowrap" } : {},
          disabled ? styles.disabled : {}
        ],
        onClick: () => setTooltipIsEnabled(!0),
        htmlFor: htmlFor2,
        ...props,
        children: [
          txtObj.start ? /* @__PURE__ */ jsx("span", { children: txtObj.start }) : null,
          txtObj.selected ? /* @__PURE__ */ jsx("strong", { children: txtObj.selected }) : null,
          txtObj.end ? /* @__PURE__ */ jsx("span", { children: txtObj.end }) : null
        ]
      }
    ));
  }
  return !tooltipIsNeeded || !tooltipCanBeShown ? content(htmlFor) : /* @__PURE__ */ jsx(
    Tooltip,
    {
      title: label,
      placement: "top",
      onClose: () => setTooltipIsEnabled(!1),
      "data-test-id": inheritDataTestId(props, "tooltip"),
      children: content()
    }
  );
});
Label.displayName = "Label";
const styles = {
  label: {
    typography: { xs: "12_18_500", sm: "14_18_500" },
    width: "100%",
    display: "inline-block",
    overflow: "hidden",
    textOverflow: "ellipsis",
    cursor: "pointer"
  },
  disabled: {
    color: (t) => t.palette.ddrow.content.disabled
  }
};
export {
  Label
};
//# sourceMappingURL=Label.js.map
